import { useGoodsSno } from '../../../hooks/useGoodsSno';
import { useQuery } from '@tanstack/react-query';
import { queryKey } from '../../../constant/queryKey';
import { aiStudioService } from 'shared/src/api';
import { useIsAnonymousUser } from 'shared/src/hooks';

type EntryPoint = 'GOODS_DETAIL_REVIEW' | 'GOODS_DETAIL_SIZE';

export const useAiFittingRedirectPath = (entryPoint: EntryPoint) => {
  const goodsSno = useGoodsSno();
  const isAnonymouseUser = useIsAnonymousUser();

  return useQuery({
    enabled: !isAnonymouseUser,
    queryKey: [
      ...queryKey.goodsRepresentativeImagesRedirectPath(goodsSno),
      entryPoint,
    ],
    queryFn: () =>
      aiStudioService.getRepresentativeImageRedirectPath({
        goods_sno: goodsSno,
        entry_point: entryPoint,
      }),
  });
};
